export default "__VITE_ASSET__9e860d20__"